import { Component, inject, signal } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  templateUrl: './delete-dialog.component.html',
  styleUrl: './delete-dialog.component.scss',
  imports: [MatButtonModule],
})
export class DeleteDialogComponent {
  public dialog = inject(MatDialogRef<DeleteDialogComponent>);
  private data = inject(MAT_DIALOG_DATA) as {
    title: string;
    message: string;
    paragraph: string;
    buttonConfirm: string;
    buttonCancel: string;
  };

  readonly title = signal(this.data.title);
  readonly message = signal(this.data.message);
  readonly paragraph = signal(this.data.paragraph);
  readonly buttonConfirm = signal(this.data.buttonConfirm);
  readonly buttonCancel = signal(this.data.buttonCancel);
}
